<template>
  <div class="detailPembayaran">
    <SOSlotBase
      :container-name="`detailPembayaran`"
      :loading="isLoading"
      :bg-grey="true"
    >
      <template v-slot:title-bar>
        <SOTitleBar :page-title="'Pembayaran'" :type="'back'" @back="back" />
      </template>

      <template v-slot:content>
        <br />
        <div class="p-x-20">
          <div class="separator p-d-4"></div>
          <div class="separator"></div>

          <p class="f-Overpass f-16 f-bold p-t-16 colorText">Smartlink</p>

          <div class="p-t-16 p-x-20 bg-white p-d-16">
            <p class="f-14 f-c-midgrey f-Overpass remove-margin">
              Halo, {{ detailPembayaran.owner.nama }} <br />Terimakasih telah melakukan pembelian aplikasi whitelabel.
	            <br/>ini adalah pembayaran cicilan ke {{detailPembayaran.cicilan_ke}} berikut tagihanya
            </p>

            <div class="p-t-16">
              <p class="f-Overpass f-14 f-bold remove-margin center-iconadd">
                Nomor Tagihan
              </p>
              <p class="f-Overpass f-14 center-iconadd">
                {{ detailPembayaran.pesanan_id }}000{{detailPembayaran.cicilan_ke}}
              </p>
            </div>

            <hr />

            <div class="p-t-8 p-d-4">
              <p class="f-Overpass f-14 f-bold remove-margin center-iconadd">
                Total Tagihan
              </p>
              <p
                class="f-Overpass f-18 f-bold colorText center-iconadd remove-margin"
              >
                Rp {{ formatRupiah(detailPembayaran.cicilan_tagihan) }}
              </p>
              <p
                class="f-Overpass f-12 center-iconadd remove-margin colorTextRed"
              >
                *Transfer tepat hingga 3 digit terakhir
              </p>
              <div class="center-iconadd">
                <button
                  class="btn btn-primary f-c-white f-12 btn-sm"
                  @click="copy"
                >
                  Salin Tagihan
                </button>
              </div>
            </div>

            <hr />

            <div class="p-t-8 p-d-4 center-iconadd">
              <p class="f-14 f-bold f-Overpass remove-margin">
                Batas Pembayaran
              </p>
              <p class="f-16 f-c-red f-Overpass remove-margin">
                {{
                  $moment(detailPembayaran.expired_at).format(
                    "DD/MM/YYYY HH:mm"
                  )
                }}
              </p>
              <p class="colorTextRed remove-margin">
                Mohon dibayar dan dikonfirmasi sebelum waktu diatas
              </p>
            </div>

            <hr />

            <p class="f-Overpass f-14 f-c-midgrey remove-margin">
              Pembayaran dapat dilakukan ke salah satu rekening berikut ini
            </p>
            <div class="bank" style="text-align: center">
              <template v-for="(dataBank, index) in dataPembayaran">
                <div class="p-t-15" :key="index">
                  <img
                    :src="
                      'https://res.cloudinary.com/sinadme/c_scale,h_50/' +
                      dataBank.data_bank.logo
                    "
                    alt="logo_bca"
                    id="img_bank"
                    class="p-t-16"
                  />
                  <p
                    class="f-Overpass f-14 p-t-16 remove-margin"
                    style="font-weight: 700; margin-top: 10px"
                  >
                    {{ dataBank.no_rekening }}
                  </p>
                  <p class="f-Overpass f-14 remove-margin">
                    {{ dataBank.nama_pemilik }}
                  </p>
                </div>
              </template>
            </div>

            <div class="p-t-8">
              <p class="f-14 f-Overpass f-c-midgrey">
                Pembelianmu dicatat dengan nomor tagihan pembayaran
                {{ detailPembayaran.pesanan_id }}000{{detailPembayaran.cicilan_ke}} Setelah anda melakukan
                pembayran melalui ATM/Internet/Mobile Banking <br />
                <span class="f-c-red f-bold">
                  Sistem smartlink akan segera melakukan verifikasi secara
                  otomatis.
                </span>
                <br />
                <br />
                Harap perhatikan akun anda dan jika anda memiliki banyak akun
                bos, pastikan akun anda sudah benar. Karena kesalahan pembayaran
                tidak dapat kami pindahkan maupun dikembalikan baik berupa koin
                atau uang rupiah.
                <br />
                <br />
                Jika kamu mengalami kendala mengenai pembayaran, silakan
                langsung hubungi CS Smartlink.
              </p>
            </div>

            <hr />

            <div class="p-t-8">
              <p class="f-16 f-bold f-Overpass">Detail Tagihan</p>

              <div class="d-flex-between-center">
                <p class="f-16 f-Overpass f-c-midgrey remove-margin">
                  Sub Total (+)
                </p>
                <p class="f-Overpass f-16 remove-margin">
                  Rp {{ formatRupiah(detailPembayaran.cicilan_nominal) }}
                </p>
              </div>
              <div class="d-flex-between-center p-t-8">
                <p class="f-16 f-Overpass f-c-midgrey remove-margin">
                  Biaya Admin (+)
                </p>
                <p class="f-Overpass f-16 remove-margin">
                  Rp
                  {{
                    formatRupiah(
                      detailPembayaran.cicilan_tagihan -
                        detailPembayaran.cicilan_nominal
                    )
                  }}
                </p>
              </div>
              <div class="d-flex-between-center p-t-8">
                <p class="f-16 f-Overpass f-bold remove-margin">Total Cicilan ke {{detailPembayaran.cicilan_ke}}</p>
                <p class="f-Overpass f-16 f-bold remove-margin">
                  Rp {{ formatRupiah(detailPembayaran.cicilan_tagihan) }}
                </p>
              </div>
            </div>
          </div>
          <p class="f-c-midgrey f-Overpass textCopy p-t-16 p-d-24">
            ⓒ 2023 PT ADA IDE LANGSUNG JALAN, All Rights Reserved
          </p>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase.vue";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar.vue";
import { mapActions, mapGetters } from "vuex";
import { moduleName } from "../store/state";
export default {
  name: "DetailPembayaran",
  components: {
    SOSlotBase,
    SOTitleBar,
  },

  computed: {
    ...mapGetters(moduleName, {
      dataOwner: "dataOwner",
      detailPembayaran: "detailPembayaran",
      dataPembayaran: "dataPembayaran",
    }),
  },

  data() {
    return {
      isLoading: false,
      idcicilan: this.$route.params.idcicilan,
    };
  },

  async mounted() {
    await this.init();
  },

  methods: {
    ...mapActions({
      dataOwner: `${moduleName}/dataOwner`,
      detailPembayaranUser: `${moduleName}/detailPembayaranUser`,
      dataBank: `${moduleName}/dataBank`,
    }),

    async copy() {
      const totalTagihanText = this.detailPembayaran.cicilan_tagihan.toString();
      try {
        await navigator.clipboard.writeText(totalTagihanText);
        this.$toast.success("Tagihan Berhasil Di Salin!");
      } catch (error) {
        console.error("Copy Failed", error);
        this.$toast.error("Tagihan Gagal Di Salin. Coba Lagi.");
      }
    },

    async init() {
      await this.detailPembayaranUser(this.idcicilan);
      await this.dataBank();
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.separator {
  border-top: 2px solid #419372;
}
.colorText {
  color: #419372;
}

.colorTextRed {
  color: #da1e28;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
}
.textCopy {
  font-size: 10px;
  text-align: center;
}
</style>
